import { render } from "./PointsToGiftCard.vue?vue&type=template&id=6dcd6ed7&scoped=true"
import script from "./PointsToGiftCard.vue?vue&type=script&lang=js"
export * from "./PointsToGiftCard.vue?vue&type=script&lang=js"

import "./PointsToGiftCard.vue?vue&type=style&index=0&id=6dcd6ed7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcd6ed7"]])

export default __exports__